import React from 'react';
import {
  Card, Form, Row, Col,
} from 'react-bootstrap';
import Required from '../../Required';
import {getCurrentStyle} from "../../../helpers/passport";

export default function Contents({ data,acceptedData }) {
  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">Содержание</Card.Header>
        <Card.Body className="p-4">
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Цель</Card.Subtitle>
            <Card.Text style={{...getCurrentStyle(data.status, data,acceptedData,'goal'),...{ whiteSpace: 'pre-wrap' }}}>{data.goal || '-'}</Card.Text>
          </Row>
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Задачи</Card.Subtitle>
            <Card.Text style={{...getCurrentStyle(data.status, data,acceptedData,'tasks'),...{ whiteSpace: 'pre-wrap' }}}>{data.tasks || '-'}</Card.Text>
          </Row>
          <Row>
            <Card.Subtitle className="mb-2 text-muted">Описание</Card.Subtitle>
            <Card.Text style={{...getCurrentStyle(data.status, data,acceptedData,'descr'),...{ whiteSpace: 'pre-wrap' }}}>{data.descr || '-'}</Card.Text>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}
